import { MultiSelect } from "@mantine/core";
import { useState, useEffect } from "react";
import _ from "lodash";

const AddressTagsInput = ({ form, name, label, placeholder, ...props }) => {
  const tags = _.get(form.values, name) ?? [];
  const [data, setData] = useState(() => tags);

  useEffect(() => {
    if (tags.length > 0) {
      setData((prev) => {
        const newTags = tags.filter((tag) => !prev.includes(tag));
        return newTags.length > 0 ? [...prev, ...newTags] : prev;
      });
    }
  }, [tags]);

  const handleChange = (value) => {
    form.setFieldValue(name, value);
    if (props.onChange) props.onChange(value);
  };

  return (
    <MultiSelect
      {...props}
      label={label}
      placeholder={placeholder}
      data={data}
      searchable
      creatable
      nothingFound="Not Found"
      value={tags}
      onChange={handleChange}
      getCreateLabel={(query) => `+ Create ${query}`}
      onCreate={(query) => {
        const trimmed = query.trim();
        if (!trimmed) return null;
        setData((current) =>
          current.includes(trimmed) ? current : [...current, trimmed]
        );
        return trimmed;
      }}
    />
  );
};

export default AddressTagsInput;
